import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { IComandasPorFase } from '../../../../commons/types/dashboard';
import { useTranslation } from '../../../../commons/useTranslasion';

interface DonutChartProps {
  data: IComandasPorFase[];
  title?: string;
}

const DonutChart: React.FC<DonutChartProps> = ({ data, title }) => {
  const { translate } = useTranslation();
  const options = {
    chart: {
      type: 'donut' as const,
    },
    colors: ['#1976d2', '#2196f3', '#64b5f6', '#90caf9', '#bbdefb'],
    labels: data.map(item => item.fase),
    legend: {
      position: 'bottom' as const,
      horizontalAlign: 'center' as const,
      fontSize: '14px',
      markers: {
        size: 12,
        strokeWidth: 0,
        shape: 'circle' as const
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total',
              fontSize: '16px',
              color: '#1976d2',
            }
          }
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val.toFixed(1) + '%';
      }
    },
    stroke: {
      width: 0
    },
    tooltip: {
      y: {
        formatter: function(value: number) {
          return value + " " + (translate("assessorados"));
        }
      }
    }
  };

  const series = data.map(item => item.quantidade);

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="donut"
      height={350}
    />
  );
};

export default DonutChart;